import { auth } from '@assetron/common/contexts/AuthWebContext';
import useConfig from '@assetron/common/hooks/useConfig';
import {
  ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL,
  AUTH_LOADING_TIMEOUT,
  BLOB_URL_REVOKE_DELAY_MS,
} from '@assetron/common/constants/constant';
import { browserPopupRedirectResolver, getRedirectResult } from 'firebase/auth';
import { useCallback } from 'react';
import handleAccountExistsWithDifferentCredError from './handleAccountExistsWithDifferentCredError';
import { postIdTokensAndRedirect } from './postIdTokensAndRedirect';

const useFetchRedirectResult = ({
  appURL,
  setIsLoading,
  showOneTap,
}: Readonly<{
  appURL: string;
  setIsLoading: (isLoading: boolean) => void;
  showOneTap: () => void;
}>) => {
  const { APP_URL } = useConfig();

  const fetchRedirectResult = useCallback(async () => {
    let redirectTimeoutId: number | undefined;
    try {
      const result = await Promise.race([
        getRedirectResult(auth, browserPopupRedirectResolver),
        new Promise<null>((resolve) => {
          redirectTimeoutId = globalThis.setTimeout(() => {
            resolve(null);
          }, AUTH_LOADING_TIMEOUT);
        }),
      ]);
      if (redirectTimeoutId !== undefined) {
        globalThis.clearTimeout(redirectTimeoutId);
      }
      if (result) {
        await postIdTokensAndRedirect(result, appURL, APP_URL);
      }
    } catch (err) {
      if (redirectTimeoutId !== undefined) {
        globalThis.clearTimeout(redirectTimeoutId);
      }
      if (err?.code === ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL) {
        handleAccountExistsWithDifferentCredError(err);
      }
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, BLOB_URL_REVOKE_DELAY_MS);
      showOneTap();
    }
  }, [appURL, setIsLoading, showOneTap, APP_URL]);

  return {
    fetchRedirectResult,
  };
};

export default useFetchRedirectResult;
